export default __webpack_public_path__ + "static/media/zalando-logo.b05c4727.png";